import { ActionSheetButton, IonBackButton, IonButtons, IonCol, IonContent, IonGrid, IonPage, IonRow, IonTitle, isPlatform, useIonActionSheet } from "@ionic/react";
import { useLiveQuery } from "dexie-react-hooks";
import { useEffect, useState } from "react";
import { RouteComponentProps } from "react-router-dom"
import { CustomLoading, Header } from "../../components";
import { db } from "../../data/db/db";
import { URLParamToArray } from "../article/articleHelper";

import "./ProductPriceAvail.scss";
import { ProductPriveAvailList } from "./ProductPriveAvailList";
import { useTranslation } from "react-i18next";

interface ProductPriceAvailProps
    extends RouteComponentProps<{
        kat: string;
    }> { }

const ProductPriceAvail: React.FC<ProductPriceAvailProps> = ({ history, match }) => {
    //artikelfinder/sku1=2003804&sku2=2003814C
    let skuStr = match.params.kat
    const [ident, setIdent] = useState<string[] | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [presentSheet] = useIonActionSheet();
    const { t } = useTranslation();

    useEffect(() => {
        setIdent(URLParamToArray(skuStr))

        return () => {
            //unmount
            setIdent(null);
        }

    }, [skuStr])

    const handleArticleClick = async (ident: string, pos: string) => {
        let article = await db.articlesOverview.get({ ident: ident })

        let buttons: ActionSheetButton[] = [
            {
                text: t("productPriceAvail.Standard Schnittwerte"),
                handler: () => { history.push(`/tabs/article/cuttingDataStd/${ident.replace(/\s+/g, '')}/${pos}`) }
            },

            {
                text: t("Abbrechen"),
                role: 'cancel',
                data: {
                    action: 'cancel',
                },
            },
        ]

        if (article?.trocut === "1") {
            buttons.push({
                text: t("productPriceAvail.Trocut Schnittwerte"),
                handler: () => { history.push(`/tabs/article/cuttingDataTro/${ident.replace(/\s+/g, '')}/${pos}`) }
            })
        }

        buttons.push({
            text: t("productPriceAvail.Schnittwert-Kalkulator"),
            handler: () => { history.push(`/tabs/calculator/form/${ident.replace(/\s+/g, '-')}/${pos}`) }
        }, {
            text: t("productPriceAvail.Artikel im Toolshop"),
            handler: () => { window.open(`https://hachenbach-toolshop.de/${ident.replace(/ /g, "-").toLowerCase()}.html`, "_blank") }
        })

        presentSheet({
            header: `${ident}-${pos}`,
            subHeader: t("productPriceAvail.sheetTitle"),
            buttons: buttons
        })
    }


    const articles = useLiveQuery(
        async () => {
            if (ident) {
                setLoading(true);
                const articles = await db.articles
                    .where('ident')
                    .anyOf(ident)
                    .toArray();
                setLoading(false)
                return articles;
            }

        },
        [ident]
    );




    return (
        <IonPage>
            <Header>
                <IonButtons slot="start">
                    <IonBackButton defaultHref="/tabs/article" text={isPlatform('ios') ? t("Zurück") : undefined} />
                </IonButtons>
                <IonTitle>{t("productPriceAvail.title")}</IonTitle>
            </Header>
            <IonContent>
                <IonGrid fixed={true} className="mainContent">
                    <IonRow>
                        <IonCol size="12">
                            {ident && articles && ident.map((identNr) => <ProductPriveAvailList key={identNr} ident={identNr} articles={articles.filter(obj => obj.ident === identNr)} handleArticleClick={handleArticleClick} />)}
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonContent>
            <CustomLoading isOpen={loading} />
        </IonPage>
    )
}

export default ProductPriceAvail;